export const IconWebsitePlanet20: {
  name: 'icon_website_planet_20-c6672d75e0aa'
} = {
  name: 'icon_website_planet_20-c6672d75e0aa'
}
